import React from 'react';
import SelectElement from 'react-select/async';

const Select = (props) => {
    const styles = {
        valueContainer: (provided, state) => ({
            ...provided,
            padding: '0rem 0.6rem',
            height: '50px',
            // paddingTop: '1rem!important',
            // height: 'calc(1.4em + 1.4rem + 2px)',
        }),
        control: (provided, state) => ({
            ...provided,
            borderRadius: '.2rem!important',
            borderColor: '#ddd!important',
        }),
        input: (provided, state) => ({
            ...provided,
            // padding: '0px',
            // paddingTop: '1rem!important',
            margin: '0px',
        }),
    };

    return (<SelectElement {...props} styles={styles} />);
};

export default Select;
